import { GenIcon } from 'react-icons';
export const MdCurrencyFlagNok = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_32093)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.9999 12.0003C23.9999 12.446 23.976 12.8811 23.9283 13.3136C23.8779 13.7912 23.7956 14.2581 23.6895 14.7198C22.4532 20.0287 17.6829 24.0005 11.9999 24.0005H11.3977V23.9846C10.9201 23.9607 10.4531 23.9103 9.99151 23.8307C9.07619 23.6769 8.19801 23.4195 7.36228 23.0693C6.87676 22.865 6.40716 22.6262 5.95613 22.3635C3.1518 20.7212 1.06646 17.9725 0.310321 14.7198C0.204197 14.2581 0.124603 13.7912 0.0741944 13.3136C0.0264385 12.8811 0.00256348 12.4433 0.00256348 12.0003C0.00256348 11.5572 0.0264385 11.1168 0.0741944 10.687C0.124603 10.2094 0.20685 9.73977 0.310321 9.28077C1.06646 6.02799 3.1518 3.27931 5.95613 1.637C6.40716 1.36903 6.87676 1.13555 7.36228 0.93126C8.19801 0.581042 9.07619 0.323686 9.99151 0.169802C10.4531 0.0902075 10.9201 0.0371437 11.3977 0.0159183V0H11.9999C17.6802 0 22.4558 3.96914 23.6922 9.28077C23.7983 9.73977 23.8779 10.2094 23.9283 10.687C23.976 11.1168 23.9999 11.5572 23.9999 12.0003Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.9999 12C23.9999 12.4457 23.976 12.8808 23.9283 13.3133C23.8779 13.7909 23.7956 14.2578 23.6895 14.7195H11.3977V23.9843C10.9201 23.9604 10.4531 23.91 9.99151 23.8304C9.07619 23.6766 8.19801 23.4192 7.36228 23.069C6.87676 22.8647 6.40716 22.6259 5.95613 22.3632V14.7195H0.310321C0.204197 14.2578 0.124603 13.7909 0.0741944 13.3133C0.0264385 12.8808 0.00256348 12.4431 0.00256348 12C0.00256348 11.5569 0.0264385 11.1165 0.0741944 10.6867C0.124603 10.2091 0.20685 9.73948 0.310321 9.28048H5.95613V1.63671C6.40716 1.36874 6.87676 1.13526 7.36228 0.930966C8.19801 0.580749 9.07619 0.323393 9.99151 0.169509C10.4531 0.0899141 10.9201 0.0368503 11.3977 0.015625V9.28048H23.6922C23.7983 9.73948 23.8779 10.2091 23.9283 10.6867C23.976 11.1165 23.9999 11.5569 23.9999 12Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.9999 11.9984C23.9999 12.4442 23.976 12.8793 23.9282 13.3118H9.99148V23.8289C9.07616 23.675 8.19798 23.4177 7.36225 23.0674V13.3118H0.0715129C0.023757 12.8793 -0.00012207 12.4415 -0.00012207 11.9984C-0.00012207 11.5554 0.023757 11.1149 0.0715129 10.6851H7.36225V0.929426C8.19798 0.579208 9.07616 0.321852 9.99148 0.167969V10.6851H23.9282C23.976 11.1149 23.9999 11.5554 23.9999 11.9984Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_32093' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
